'use client';

import { c as _c } from "react/compiler-runtime";
import AttachmentsToolbarContext from './particles/AttachmentsToolbarContext';
import AttachmentsToolbarContainer from './particles/AttachmentsToolbarContainer';
import AttachmentsToolbarHeader from './particles/AttachmentsToolbarHeader';
import AttachmentsToolbarBody from './particles/AttachmentsToolbarBody';
const AttachmentsToolbarClient = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AttachmentsToolbarContext><AttachmentsToolbarContainer><AttachmentsToolbarHeader /><AttachmentsToolbarBody /></AttachmentsToolbarContainer></AttachmentsToolbarContext>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default AttachmentsToolbarClient;